// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/styles.scss
// module id = 1219
// module chunks = 0